import MultiTenantCustomerSearch from '@components/CustomerSearch/MultiTenantCustomerSearch';
import { useState } from 'react';
import CustomerDetails from '../CustomerDetails';
import classNames from 'classnames';
import useTasks from '@modules/TasksModule/hooks/useTasks';
import TasksModule from '@modules/TasksModule';
import TaskLoadingOverlay from '@app/layouts/MainLayout/components/TaskLoadingOverlay/TaskLoadingOverlay';

export type SelectedCustomer = {
  tenantId: string;
  customerId: string;
};

interface MultiTenantTaskViewProps {
  taskId: string | undefined;
}

/**
 * This component is used to display the customer search and customer details for a multi-tenant task.
 * A task is multi-tenant if it does not have a tenantId associated with the task.
 *
 */
const MultiTenantTaskView = ({ taskId }: MultiTenantTaskViewProps) => {
  const [selectedCustomer, setSelectedCustomer] = useState<
    SelectedCustomer | undefined
  >(undefined);

  const { taskById } = useTasks();

  const handleBackClick = () => {
    setSelectedCustomer(undefined);

    // reset task attributes
    const task = taskId ? taskById[taskId] : null;
    if (!task) {
      return;
    }

    TasksModule.setCustomerOnTask(task.id, undefined);
  };

  const handleCustomerSelect = (
    customerId: string,
    customerName: string,
    tenantId: string,
  ) => {
    setSelectedCustomer({ tenantId, customerId });

    // set task attributes
    const task = taskId ? taskById[taskId] : null;
    if (!task) {
      return;
    }

    TasksModule.setCustomerOnTask(task.id, {
      id: customerId,
      name: customerName,
    });
  };

  return (
    <div className={classNames('p-x-3', 'p-y-2', 'of-y-auto', 'd-f')}>
      <TaskLoadingOverlay taskId={taskId}>
        {selectedCustomer && (
          <CustomerDetails
            customerId={selectedCustomer.customerId}
            tenantId={selectedCustomer.tenantId}
            onBackClick={handleBackClick}
          />
        )}
        <MultiTenantCustomerSearch
          show={!selectedCustomer}
          onSelectCustomer={handleCustomerSelect}
        />
      </TaskLoadingOverlay>
    </div>
  );
};

export default MultiTenantTaskView;
